import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BaseElement, customElement } from '../base-element';
import './text';
import { Translate } from '../base-element/mixins/translation-mixin';

@customElement('ps-text-body')
export class TextBodyWC extends Translate(BaseElement) {
  /** Body font size. */
  @property() size: 'medium' | 'small' = 'medium';

  /** Body variant */
  @property() variant: 'primary' | 'secondary' | 'tertiary' = 'primary';

  /** Text-align */
  @property() textAlign: 'start' | 'center' | 'end' | 'justify' = 'start';

  /** Truncate option */
  @property({ type: Boolean }) truncate?: boolean = false;

  /** Number of lines before truncate */
  @property({ type: Number, reflect: true, attribute: 'truncate-lines' })
  truncateLines?: number;

  render() {
    const sizeOption = this.size === 'small' ? '3xsmall' : '2xsmall';

    return html`
      <ps-text
        size=${sizeOption}
        variant=${this.variant}
        textAlign=${this.textAlign}
        ?truncate=${this.truncate}
        truncate-lines=${ifDefined(this.truncateLines)}
        data-cy="text-body"
      >
        <slot></slot>
      </ps-text>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-text-body': TextBodyWC;
  }
  enum PSElementTagNameMap {
    'ps-text-body' = 'ps-text-body',
  }
}
